<template>
    <Link v-if="link" :post_link="link" class="link" :class="classname">
        <slot></slot>
    </Link>
    <span v-else :class="classname" class="no-link">
        <slot></slot>
    </span>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'ui-button',

    components: {
        Link,
    },

    props: {
        link: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'border',
        },
        size: {
            type: String,
            default: 'base',
        },
        color: {
            type: String,
            default: 'grey',
        },
    },

    data() {
        return {
            classname: ['ui-button'],
        }
    },


    mounted() {
        this.classname.push('size-' + this.size);
        this.classname.push('color-' + this.color);
        this.classname.push('type-' + this.type);    
    },
}

</script>

<style lang="scss">
    .ui-button {
        display: inline-block;
        cursor: pointer;
        box-sizing: border-box;

        &.type-border {
            border: .3rem solid;
        }

        // &.size-large {
        //     line-height: 3rem;
        //     height: 3rem;
        //     padding: 1rem 1.5rem;
        //     font-size: var(--large-size);
        // }

        &.size-base {
            font-size: var(--base-size);
            line-height: 1.2;
            padding: var(--padding-25) var(--padding-x2);
            
            &.type-border {
                line-height: 1;
            }
        }

        &.size-small {
            $size: 2.4rem;
            line-height: 1.2;
            height: $size;
            padding: 0.333rem 3rem;
            font-size: var(--small-size);
            border-width: .12rem;

            &.type-border {
                line-height: 1.1;
            }
        }

        &.type-border.color-black {
            color: var(--black);
            background-color: transparent;

            &.link:hover {
                color: var(--white);
                background-color: var(--black);
                border-color: var(--black);
                opacity: 1;
            }
        }

        &.type-border.color-grey {
            color: var(--font-color);
            background-color: transparent;

            &:hover {
                color: var(--white);
                background-color: var(--black);
                border-color: var(--black);
                opacity: 1;
            }
        }

        
        &.type-bg.color-grey {
            color: var(--font-color);
            background: var(--grey);

            &.link:hover {
                color: var(--white);
                background-color: var(--black);
                border-color: var(--black);
                opacity: 1;
            }
        }

        // &.type-bg.color-red {
        //     color: var(--font-color);
        //     background: var(--pink);

        //     &.link:hover {
        //         color: var(--white);
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-blue {
        //     color: var(--font-color);
        //     background: var(--blue);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }

        // &.type-bg.color-orange {
        //     color: white;
        //     background: var(--orange);

        //     &.link:hover {
        //         color: white;
        //         background-color: black;
        //         border-color: black;
        //         opacity: 1;
        //     }
        // }


        &.only-text {
            border-color: transparent !important;
            background-color: transparent !important;
            cursor: default;
        }



    }

    @media only screen and (max-width: 767px) {
        .ui-button {

            // &.size-base {
            //     font-size: var(--base-size);
            //     line-height: 1.2;
            //     padding: var(--padding-25) var(--padding-x2);
                
            //     &.type-border {
            //         line-height: 1;
            //     }
            // }

            &.size-small {
                $size: 4.4rem;
                height: $size;
            }

          


        }

    }
</style>